<template lang="pug">
  .make-an-entry-visibility
    BIcon(icon="lock")
    span.has-text-grey.is-size-7 {{text}}
</template>

<script>
export default {
  name: "MakeAnEntryVisibility",

  props: {
    text: {
      type: String,
      default: "Always Private"
    }
  }
};
</script>

<style lang="sass">
.make-an-entry-visibility
  position: absolute
  left: 3.4rem
  bottom: 1.4rem
  display: flex
  align-items: center
</style>
